import { array, partial, string } from 'io-ts/Decoder';

import { Id as RecipeGroupId } from '../../../../../whole-house/canvas/recipe-group/Id';

export const Request = partial({
	name: string,
	parentId: RecipeGroupId,
	recipeIds: array(string),
});
